import { SERVICE_MARKETPLACE_LIST_REQUEST } from "./constants";

export const serviceMarketplaceListRequest = data => {
  return {
    type: SERVICE_MARKETPLACE_LIST_REQUEST,
    data
  };
};
